const oneDayMillis = 24 * 60 * 60 * 1000;
const months = [
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember',
];

function inXDays(numDays) {
    return new Date(Date.now() + numDays * oneDayMillis);
}

function format(date) {
    const day = date.getDate();
    const month = date.getMonth();
    const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${day}. ${months[month]} ${time}`;
}

function pad(arg) {
    if (arg < 10) {
        return `0${arg}`;
    }

    return `${arg}`;
}

export function formatDate(date) {
    const realDate = typeof date === 'string' ? new Date(date) : date;

    return format(realDate);
}

function pluralize(num, singular, plural) {
    return `${num} ${num === 1 ? singular : plural}`;
}

export function minutesToInWords(minutes) {
    if (minutes >= 60 * 24) {
        const days = Math.floor(minutes / (60 * 24));
        return pluralize(days, 'døgn', 'døgn');
    }

    if (minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        return pluralize(hours, 'time', 'timer');
    }

    return pluralize(minutes, 'minutt', 'minutter');
}

// todo: remove function
// https://jira.finn.no/browse/CUS-1959
export function inSevenDays() {
    return inXDays(7);
}



// WEBPACK FOOTER //
// ./safeTrade/getDeadline.js